import { TableHeader } from '@fairfashion/design-system'

import { IReportsResumeResponse } from '../../sdk/reports/reports.types'

import { ClientsCustomColumn } from './components/clients-custom-column.comp'

export const isValidHeader = (header: string) => {
  switch (header) {
    case 'createdAt':
    case 'updatedAt':
    case 'deletedAt':
    case 'id':
    case 'address':
      return false

    default:
      return true
  }
}

export const getCustomHeader = (header: string) => {
  const customHeader: Record<string, TableHeader> = {
    clients: {
      key: 'clients',
      label: 'Clientes',
      width: '60px',
      customRender: (value: any) => <ClientsCustomColumn value={value} />,
    },
  }

  if (customHeader[header]) {
    return customHeader[header]
  }
}

export const translateKey = (key: string) => {
  switch (key) {
    case 'name':
      return 'Nome'
    case 'taxId':
      return 'Documento'
    case 'taxIdType':
      return 'Tipo de documento'
    case 'segment':
      return 'Segmento'
    case 'email':
      return 'Email'
    case 'unkown':
      return 'Desconhecido'

    default:
      return key
  }
}

export const textInfo = (name: string) => {
  switch (name) {
    case 'providers-pending-invoices':
      return {
        title: 'NFs com origem pendente',
        subtitle:
          'Esse relatório exibe a lista de NFs que possuem dados de origem pendentes.',
        counterTitle: 'Número de NF pendentes',
        icon: 'file4',
      }
    case 'providers-with-incomplete-register':
      return {
        title: 'Fornecedores com registro incompleto',
        subtitle:
          'Esse relatório exibe a lista dos fornecedores que possuem registros incompletos, indicando aqueles que não possuem documento, segmento, email ou endereço;',
        counterTitle: 'Número de Fornecedores',
        icon: 'group',
      }
    case 'providers-with-wrong-segment':
      return {
        title: 'Fornecedores com segmentos não encontrados ou incorretos',
        subtitle:
          'Esse relatório exibe a lista dos fornecedores que não possuem segmentos associados na plataforma ou segmentos desconhecidos da minha cadeia.',
        counterTitle: 'Número de Fornecedores',
        icon: 'user_unfollow',
      }
    case 'providers-without-user':
      return {
        title: 'Fornecedores sem usuário vinculado',
        subtitle:
          'Esse relatório exibe a lista dos fornecedores da minha cadeia que não possuem usuários (e dados de contato) vinculados.',
        counterTitle: 'Número de Fornecedores',
        icon: 'user_unfollow',
      }

    default:
      break
  }
}

export const getCount = (
  resume: IReportsResumeResponse[] | null,
  name: string,
) => {
  const result = resume?.find((obj) => obj.name === name)
  if (result) {
    return Math.ceil(result?.count / 5) ?? 1
  } else {
    return 1
  }
}

export const removeSubstring = (
  stringOriginal: string,
  stringToRemove: string,
): string => {
  if (stringOriginal.startsWith(stringToRemove)) {
    return stringOriginal.slice(stringToRemove.length)
  } else {
    return stringOriginal
  }
}
